import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: flex-start;\n  padding: 18px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  width: 100px;\n  height: auto;\n  margin-right: 18px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  font-size: 14px;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  color: ",
        ";\n\n  ",
        " {\n    letter-spacing: 1px;\n    text-align: left;\n    font-size: 16px;\n    width: 100%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  a {\n    color: ",
        ";\n  }\n  a:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: inline-block;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n\n  margin-top: 23px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  text-transform: uppercase;\n\n  font-size: 14px;\n  letter-spacing: 1px;\n  color: ",
        ";\n\n  &:last-child {\n    margin-bottom: 0px;\n  }\n\n  &:after {\n    content: '/';\n    margin-left: 4px;\n    margin-right: 4px;\n  }\n\n  &:last-child:after {\n    content: '';\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatCurrency } from "@purple-dot/libraries/src/formatter";
import React from "react";
import styled from "styled-components";
import { BelowMobile } from "../../common/media-queries";
import { useTranslation } from "../../use-translation";
import { TextButton } from "../components/TextButton";
import { useAnalytics } from "../PageTypes/IframePage/AnalyticsProvider";
function Item(param) {
    var lineItem = param.lineItem, RemoveLineItemTask = param.RemoveLineItemTask;
    var analytics = useAnalytics();
    var i18n = useTranslation().i18n;
    var sku = lineItem.sku;
    var isRemoving = RemoveLineItemTask.isPending && RemoveLineItemTask.request.lineItemId === lineItem.id;
    return /*#__PURE__*/ _jsxs(ItemContainer, {
        "data-testid": "cart-item",
        children: [
            /*#__PURE__*/ _jsx(Image, {
                src: sku.imageURL,
                alt: sku.name
            }),
            /*#__PURE__*/ _jsxs(ItemDetailsContainer, {
                children: [
                    /*#__PURE__*/ _jsx(Name, {
                        "data-testid": "product-name",
                        children: /*#__PURE__*/ _jsx("a", {
                            href: sku.url,
                            target: "_parent",
                            children: sku.name
                        })
                    }),
                    /*#__PURE__*/ _jsx(VariantRowContainer, {
                        "data-testid": "variant-options",
                        children: sku.displayOptions.map(function(param) {
                            var label = param.label, value = param.value;
                            return /*#__PURE__*/ _jsx(VariantOption, {
                                children: value
                            }, "".concat(label, "-").concat(value));
                        })
                    }),
                    /*#__PURE__*/ _jsxs(PriceRow, {
                        children: [
                            /*#__PURE__*/ _jsx(Price, {
                                "data-testid": "product-price",
                                children: formatCurrency(sku.price, i18n.resolvedLanguage)
                            }),
                            /*#__PURE__*/ _jsx(TextButton, {
                                "data-testid": "remove-item",
                                disabled: isRemoving,
                                onClick: function() {
                                    analytics.track("Product Removed");
                                    RemoveLineItemTask.run({
                                        lineItemId: lineItem.id
                                    });
                                },
                                children: isRemoving ? "Removing..." : "Remove"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var ItemContainer = styled.li(_templateObject());
var Image = styled.img(_templateObject1());
var LabelText = styled.span(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.header.color;
}, BelowMobile);
var Name = styled(LabelText)(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.text.header.color;
}, function(param) {
    var theme = param.theme;
    return theme.text.header.color;
});
var Price = styled(LabelText)(_templateObject4());
var PriceRow = styled.div(_templateObject5());
var ItemDetailsContainer = styled.div(_templateObject6());
var VariantRowContainer = styled.div(_templateObject7());
var VariantOption = styled.div(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.text.body.color;
});
export default Item;
